import { useSelector } from "react-redux";
import "../App.css";
import MessagesView from "../components/MessagesView";

type MessagesProps = {
    messageEvents: any[]
}
function Messages({messageEvents}: MessagesProps) {

  const user = useSelector((state: any) => state.user);

  const msgsContent = <MessagesView newMessages={messageEvents}/>;

  return <div className="App">{user && user.id && msgsContent}</div>;
}

export default Messages;
